// Mock data for Cafe Konditorei Rieppel

export const bakeryInfo = {
  name: "Cafe Konditorei Rieppel",
  slogan: "Seit 1938 Wiener Backtradition",
  address: "Märzstraße 71, 1150 Wien",
  phone: "01 9825285",
  yearsFounded: 1938,
  openAllYear: true,
  knownFrom: "meinbezirk.at",
  owner: "Stefan Rieppel",
  employees: 12,
  schanigarten: 20
};

export const openingHours = [
  { day: "Montag", hours: "05:30–18:30" },
  { day: "Dienstag", hours: "05:30–18:30" },
  { day: "Mittwoch", hours: "05:30–18:30" },
  { day: "Donnerstag", hours: "05:30–18:30" },
  { day: "Freitag", hours: "05:30–18:30" },
  { day: "Samstag", hours: "05:30–14:00" },
  { day: "Sonntag & Feiertage", hours: "07:00–14:00" }
];

export const services = [
  {
    id: 1,
    title: "Frühstück",
    description: "Starten Sie den Tag mit frischem Gebäck, knusprigen Semmeln und duftendem Kaffee.",
    icon: "Coffee"
  },
  {
    id: 2,
    title: "Schulbrot Service",
    description: "Gesunde und leckere Jausen für Ihre Kinder – täglich frisch zubereitet.",
    icon: "GraduationCap"
  },
  {
    id: 3,
    title: "Kindergarten & Schul-Catering",
    description: "Zuverlässige Belieferung von Kindergärten, Schulen und Restaurants.",
    icon: "Truck"
  },
  {
    id: 4,
    title: "Spezialtorten & Festtagskuchen",
    description: "Individuelle Torten für Hochzeiten, Geburtstage und besondere Anlässe.",
    icon: "Cake"
  },
  {
    id: 5,
    title: "Diabetiker-Backwaren",
    description: "Kuchen, Gebäck und Brot speziell für Diabetiker – ohne Kompromisse beim Geschmack.",
    icon: "Heart"
  },
  {
    id: 6,
    title: "365 Tage geöffnet",
    description: "Wir sind das ganze Jahr für Sie da – auch an Sonn- und Feiertagen.",
    icon: "CalendarCheck"
  }
];

export const products = [
  {
    id: 1,
    category: "Brot & Gebäck",
    items: ["Hausbrot", "Kornspitz", "Semmeln", "Vollkornbrot", "Bauernbrot"],
    image: "https://images.unsplash.com/photo-1674770067314-296af21ad811?w=800&q=80"
  },
  {
    id: 2,
    category: "Feingebäck",
    items: ["Croissants", "Kipferl", "Plunder", "Topfengolatsche", "Nussschnecke"],
    image: "https://images.unsplash.com/photo-1625425405713-a0753f7552a9?w=800&q=80"
  },
  {
    id: 3,
    category: "Torten & Kuchen",
    items: ["Sachertorte", "Apfelstrudel", "Topfenstrudel", "Linzer Torte", "Käsekuchen"],
    image: "https://images.unsplash.com/photo-1639665047213-d2b6eb288dc8?w=800&q=80"
  }
];

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_7e52a33b-4c46-4bf0-be21-c264c50abfa9/artifacts/8cty36r8_image.png",
  bread: "https://images.unsplash.com/photo-1674770067314-296af21ad811?w=800&q=80",
  pastries: "https://images.unsplash.com/photo-1625425405713-a0753f7552a9?w=800&q=80",
  elegantPastries: "https://images.unsplash.com/photo-1625425404751-19b16c027511?w=800&q=80",
  cakes: "https://images.unsplash.com/photo-1639665047213-d2b6eb288dc8?w=800&q=80",
  specialCake: "https://images.unsplash.com/photo-1702501438888-57e773135dd0?w=800&q=80"
};
